import { render } from "./OverOns.vue?vue&type=template&id=7d6d16d5&scoped=true"
import script from "./OverOns.vue?vue&type=script&lang=js"
export * from "./OverOns.vue?vue&type=script&lang=js"

import "./OverOns.vue?vue&type=style&index=0&id=7d6d16d5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d6d16d5"]])

export default __exports__